const entry = resolve => {
  require.ensure([], () => {
    resolve(require('../views/travel/invoiceEntry.vue'))
  }, 'travel')
}
  //选择行程
  const appScheduleList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/scheduleList.vue'))
    }, 'travel')
  }
  //开发票
  const appElecPage = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/invoiceElecPage.vue'))
    }, 'travel')
  }

  // 开具收款凭证
  const appProofPage = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/invoiceProofPage.vue'))
    }, 'travel')
  }  

  // 开具收款凭证成功
  const appProofPageSuccess = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/invoiceProofPageSuccess.vue'))
    }, 'travel')    
  }

  // 收款凭证详情
  const appProofDetail = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceDetails/appProofDetail.vue'))
    }, 'travel')       
  }

  //开发票成功
  const appInvoiceSuccess = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/invoiceSuccess.vue'))
    }, 'travel')
  }

  //开票中
  const InvoicingSuccess = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/InvoicingSuccess.vue'))
    }, 'travel')
  }

  //零担发票抬头列表
  const lookUpList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceLookUp/lookUpList.vue'))
    }, 'travel')
  }
  //零担发票抬头添加
  const addLookUp = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceLookUp/addLookUp.vue'))
    }, 'travel')
  }

  //零担发票历史
  const historyList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceHistory/historyList.vue'))
    }, 'travel')
  }
  //零担发票历史外层
  const outerLayer = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceHistory/outerLayer.vue'))
    }, 'travel')
  }

  //零担电子发票
  const electronicDetails = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceDetails/electronicDetails.vue'))
    }, 'travel')
  }

  //重新发送行程单
  const send = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceDetails/send.vue'))
    }, 'travel')
  }

  //发票详情
  const invoiceDetail = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/invoiceDetail.vue'))
    }, 'travel')
  }
  //支付返回中转页面
  const transit = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/transit.vue'))
    }, 'travel')
  }

  //地址列表
  const addressList = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/addressList.vue'))
    }, 'travel')
  }
  //添加地址
  const addAddress = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/addAddress.vue'))
    }, 'travel')
  }
  //开票规则
  const appInvoiceRule = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/invoiceRule.vue'))
    }, 'travel')
  }
  //专票认证书
  const appAuthBook = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/authbook.vue'))
    }, 'travel')
  }
  //零担更多发票信息
  const papEleMore = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceDetails/papEleMore.vue'))
    }, 'travel')
  }

  //零担资质认证审核
  const appInvoiceDesc = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceDesc/index.vue'))
    }, 'travel')
  }
  //零担资质认证审核
  const invoiceMiddle = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoice/invoiceMiddle.vue'))
    }, 'travel')
  }

  //小拉临时
  const indexPage = resolve=>{
    require.ensure([], () => {
      resolve(require('../views/travel/index.vue'))
    }, 'travel')
  }

  // 小拉app-安卓-ios-鸿蒙 顺风车估价页新增[无发票说明]入口
  const noInvoiceDesc = resolve => {
    require.ensure([], () => {
      resolve(require('../views/travel/invoiceDesc/noInvoiceDesc.vue'))
    }, 'travel')
  }


  export default [
    {path: '/xl/entry', component: entry, meta: {title: '发票'}},
    {path: '/xl/appScheduleList', component: appScheduleList, meta: {title: '选择行程'}},
    {path: '/xl/appInvoiceSuccess', component: appInvoiceSuccess, meta: {title: '开票成功'}},
    {path: '/xl/InvoicingSuccess', component: InvoicingSuccess, meta: {title: '开票成功'}},
    {path: '/xl/addressList', component: addressList, meta: {title: '更多地址'}},
    {path: '/xl/addAddress', component: addAddress, meta: {title: '添加地址'}},
    {path: '/xl/appInvoiceRule', component: appInvoiceRule, meta: {title: '开票规则'}},
    {path: '/xl/appAuthBook', component: appAuthBook, meta: { title: '开票资质确认书' } },
    {path: '/xl/appInvoiceDesc', component: appInvoiceDesc, meta: { title: '开票说明' } },
    // {path: '/xl/passport', component: invoiceMiddle, meta: { title: '用户认证' } },
    {path: '/xl/send', component: send, meta: { title: '电子开票详情' } },
    {path: '/xl/lookUpList', component: lookUpList, meta: {title: '抬头管理'}},
    {path: '/xl/addLookUp', component: addLookUp, meta: {title: '添加抬头'}},
    {path: '/xl/historyList', component: historyList, meta: {title: '同期申请发票'}},
    {path: '/xl/outerLayer', component: outerLayer, meta: {title: '开票历史'}},
    {path: '/xl/electronicDetails', component: electronicDetails, meta: {title: '电子开票详情'}},
    {path: '/xl/appInvoiceDetail', component: invoiceDetail, meta: {title: '发票详情'}},
    {path: '/xl/transit', component: transit, meta: {title: '开票历史'}},
    {path: '/xl/papEleMore', component: papEleMore, meta: {title: ''}},
    {path: '/xl/appElecPage', component: appElecPage, meta: {title: '开具电子发票'}},
    {path: '/xl/index', component: indexPage, meta: {title: '开票公告'}},//小拉临时跳转


    // 2024.4.15 新增
    {path: '/xl/appProofPage', component:appProofPage, meta: {title: '开具收款凭证'}},
    {path: '/xl/appProofPageSuccess', component:appProofPageSuccess, meta: {title: '开具收款凭证'}},
    {path: '/xl/appProofDetail' , component:appProofDetail, meta: {title: '收款凭证详情'}},
    // 2025.7.10 新增
    {path: '/xl/noInvoiceDesc' , component:noInvoiceDesc, meta: {title: '无发票说明'}},


  ]




// WEBPACK FOOTER //
// ./src/router/travel.js